module.exports = __webpack_public_path__ + "static/img/logo.fb03048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/logo.png
// module id = QB7A
// module chunks = 0